
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartTidalIec as ObiChartTidalIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-tidal-iec.js';
 
 
 

 
 export const ObiChartTidalIec = createComponent({
   react: React,
   tagName: 'obi-chart-tidal-iec',
   elementClass: ObiChartTidalIecElement,
   events: {
     
   }
  });
 
 